import {
  CreateGUFNewLicenceTask,
  CreateGUFStartRegistrationTask,
  EditGUFNewLicenceTask,
  EditGUFStartRegistrationTask,
  InstallationFunctionOptions,
} from "@nens/brostar/uploadapi-client";

// Enkel deze twee bodemsystemen hebben energie kenmerken
export const ENERGY_INSTALLATION_FUNCTION_VALUES: readonly InstallationFunctionOptions[] = [
  "geslotenBodemenergiesysteem",
  "openBodemenergiesysteem",
];

// Check om te zien of het energie kenmerken zou moeten hebben
// op basis van het installatie type
export const isEnergyInstallationFunction = (
  installationFunction: InstallationFunctionOptions | undefined
) =>
  installationFunction !== undefined &&
  ENERGY_INSTALLATION_FUNCTION_VALUES.includes(installationFunction);

// Manier om de data op te schonen, om zeker te weten dat
// als er eerst een bodemenergie systeem is aangeleverd,
// dat deze gegevens niet meekomen (als ze bijvoorbeeld nog in de cache zaten o.i.d.)
export const sanitizeGufEnergyCharacteristicsForSubmit = <
  T extends
    | EditGUFNewLicenceTask
    | CreateGUFNewLicenceTask
    | CreateGUFStartRegistrationTask
    | EditGUFStartRegistrationTask
>(
  formData: T
): T => {
  const installations = formData.sourcedocumentData.designInstallations;
  if (!Array.isArray(installations)) return formData;

  return {
    ...formData,
    sourcedocumentData: {
      ...formData.sourcedocumentData,
      designInstallations: installations.map((installation) =>
        isEnergyInstallationFunction(installation.installationFunction)
          ? installation
          : { ...installation, energyCharacteristics: undefined }
      ),
    },
  };
};
